import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { TextHelper } from '../../../../../../shared/helpers/text.helper';
import { AssignmentChangeCommunicationResultModel } from '../../../models/assignment-change-communication-result.model';
import { AssignmentCommunicationUpdatePostModel } from '../../../models/assignment-communication-update-post.model';
import { AssignmentsCommunicationStateService } from '../../../services/assignments-communication-state-service';
import { AssignmentsCommunicationService } from '../../../services/assignments-communication.service';

@Component({
    selector: 'app-assignment-communication-update-modal',
    templateUrl: './assignment-communication-update-modal.component.html',
    styleUrl: './assignment-communication-update-modal.component.scss'
})
export class AssignmentCommunicationUpdateModalComponent {
    assignmentCommunicationUpdateModel?: AssignmentCommunicationUpdatePostModel;
    updateResponse: AssignmentChangeCommunicationResultModel | null = null;
    updateForm: FormGroup | null = null;
    assignmentId!: number;
    isLoading: boolean = false;

    constructor(
        private assignmentCommunicationStateService: AssignmentsCommunicationStateService,
        private assignmentCommunicationService: AssignmentsCommunicationService,
        private formBuilder: FormBuilder,
        private bsModalRef: BsModalRef,
        private textHelper: TextHelper
    ) { }

    ngOnInit(): void {
        this.loadData();
    }

    private loadData(): void {

        this.assignmentCommunicationService.getAssignmentCommunication(this.assignmentId)
            .subscribe({
                next: (communicationModel) => {
                    this.initForm(communicationModel.update);
                }
            });
    }

    protected saveForm(): void {
        if (this.updateForm == null) return;
        if (!this.updateForm.valid) return;

        this.sendAssignmentCommunicationUpdate();
    }

    private sendAssignmentCommunicationUpdate(): void {
        this.isLoading = true;

        this.assignmentCommunicationUpdateModel = { update: this.updateForm?.value.update };
        this.assignmentCommunicationService.sendAssignmentCommunicationUpdate(this.assignmentId, this.assignmentCommunicationUpdateModel)
            .subscribe({
                next: (response) => {
                    this.isLoading = false;
                    if (response.isSuccess) {
                        this.assignmentCommunicationStateService.loadAssignmentCommunication(this.assignmentId);
                        this.bsModalRef.hide();
                    }
                    this.updateResponse = response;
                },
                error: (error) => {
                    this.isLoading = false;
                }
            });
    }

    private initForm(value: string): void {
        const sanitizedText = this.textHelper.getSanitizedUpdateText(value);

        this.updateForm = this.formBuilder.group({
            update: [sanitizedText]
        });
    }

}
